import {MOON_650} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const CollectionsSummary = styled.div`
  margin-bottom: 18px;
  margin-top: 18px;
  padding-left: 4px;
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  color: ${MOON_650};
`;
CollectionsSummary.displayName = 'S.CollectionsSummary';

export const PaginationPanel = styled.div`
  margin-top: 14px;
  align-self: flex-end;
`;
PaginationPanel.displayName = 'S.PaginationPanel';
